// extracted by mini-css-extract-plugin
export default {"container":"ConfirmedBooking_container__uK1rs","image":"ConfirmedBooking_image__KJsV3","title":"ConfirmedBooking_title__rIGh3","text":"ConfirmedBooking_text__Ci++5"};